'use client'
import dynamic from 'next/dynamic'
import Image from "next/image"
import styled, {css} from "styled-components"
import {imgMask} from "@/styles/product"
import { useRef, useEffect, useState } from "react"
import Loading from "@/components/loading"
import { ErrorTryAgain } from "@/components/error"
type Props = {
    url: string,
    width: number,
    height: number,
    poster?: string,
    isReady: boolean,
    isError: boolean,
    onPlayTrack?: (status: string) => void
}

const PlayerWrapper = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  ${({width, height}: Partial<Props>) => css`
    width: ${width}px;
    height: ${height}px;
    position: relative;
  `}
  .player {
    opacity: 0;
    ${({isReady, isError}: Partial<Props>) => {
      if(isReady && !isError) {
        return css`
          opacity: 1;
          `}
    }
    }
    ${({isError}: Partial<Props>) => {
      if(isError) {
        return css`
          display: none;
          `}
    }
    }
  }
  ${imgMask}
  .player-loading, .player-error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 66;
  }
  video {
    position: relative;
    z-index: 60;
  }
`



const playerConfig = {
    file: {
        attributes: {
            controlsList: 'nodownload', // 禁用下载
            disablePictureInPicture: true, // 禁用画中画
            muted: true,
            autoPlay: true
        }
    },
};
export default function Player({url, width, height, poster, onPlayTrack}: Props) {
    const playRef = useRef<React.Component>()
    const [isReady, setIsReady] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)

    const NoSSRPlayer = dynamic(async () => {
        const {default: IntlPlayer } = await import('react-player')

        return ({ forwardedRef, ...props }) => <IntlPlayer ref={forwardedRef} {...props} />;
    }, {
        ssr: false
    })
    const onPlayReady = ()=> {

        setIsReady(true)
    }
    const onPlayError = ()=> {
        setIsReady(true)
        setIsError(true)
    }
    const statusProps = {isReady, width, height, isError}

    const onTry = ()=> {
        setIsReady(false)
        setIsError(false)
    }
    return <PlayerWrapper {...statusProps}>
        { !isReady && <Loading className="player-loading"/> }
        { isError && <ErrorTryAgain className="player-error" onEmit={onTry}/> }
        <div className="player" >
            <NoSSRPlayer
                forwardedRef={playRef}
                url={url}
                controls={true}
                config={playerConfig}
                width={width}
                height={height}
                onError={onPlayError}
                onReady={onPlayReady}
                onPlay={()=> onPlayTrack?.('play')}
                onPause={()=> onPlayTrack?.('pause')}
            />
        </div>

    </PlayerWrapper>
}